import { render, staticRenderFns } from "./treeInfo.vue?vue&type=template&id=2d046efd&"
import script from "./treeInfo.vue?vue&type=script&lang=js&"
export * from "./treeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/tree/treeInfo.vue"
export default component.exports